import { OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE } from 'Constants'
import DateRestriction from 'Pages/Workflow/components/Step4/DateRestriction'
import Footer from 'Pages/Workflow/components/Step4/Footer'
import MailingFrequency from 'Pages/Workflow/components/Step4/MailingFrequency'
import { ModalFilterDetails } from 'Pages/Workflow/components/Step4/ModalFilterDetails'
import SegmentationBox from 'Pages/Workflow/components/Step4/SegmentationBox'
import SendingTime from 'Pages/Workflow/components/Step4/SendingTime'
import { resetStepCallback } from 'Pages/Workflow/recoil/callbacks/callbacks'

import { OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE } from 'Constants/index'
import { workflowDetails } from 'Pages/Workflow/recoil/state/data'
import { Flex } from 'mailup-web-components'
import { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'

const WorkflowWizardFourthStep = () => {
  const { Type } = useRecoilValue(workflowDetails)

  const resetStep = useRecoilCallback(resetStepCallback, [])

  useEffect(() => {
    return () => {
      resetStep()
    }
  }, [])

  return (
    <Flex flexDirection='column'>
      <ModalFilterDetails />
      {Type !== OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE && (
        <SegmentationBox />
      )}
      <SendingTime />
      {Type === OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE && (
        <>
          <MailingFrequency />
        </>
      )}
      <DateRestriction />
      <Footer />
    </Flex>
  )
}

export default WorkflowWizardFourthStep
